import { CommonProps } from '@repo/types'
import { observer } from 'mobx-react-lite'
import React from 'react'

export const Nav = observer(function Nav({ children }: CommonProps): React.ReactElement {
  return <nav className='flex flex-col'>{children}</nav>
})
